import { computed } from '@nuxtjs/composition-api';
import pageRef from '@shared/util/page-ref';

interface ValidationItem {
  key: string;
  missingValues: string[];
}

const useProductValidation = () => {
  const state = pageRef<ValidationItem[]>([], 'useProductValidation-state');
  const showErrors = pageRef(false, 'useProductValidation-showErrors');

  const set = (key: string, missingValues: string[]) => {
    state.value = state.value
      .filter((v: ValidationItem) => v.key !== key)
      .concat(missingValues.length ? [{ key, missingValues }] : []);
    if (!state.value.length) {
      showErrors.value = false;
    }
  };

  const get = (key: string): string[] =>
    state.value
      .filter((v: ValidationItem) => v.key === key)
      .map(({ missingValues }: ValidationItem) => missingValues)
      .shift() ?? [];

  const validate = () => {
    if (!state.value.length) return true;
    showErrors.value = true;
    return false;
  };

  const isValid = computed(() => !state.value.length);

  return {
    set,
    get,
    validate,
    isValid,
    showErrors,
  };
};

export default useProductValidation;
